import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=08a494d0&scoped=true"
import script from "./DataSummary.vue?vue&type=script&lang=js"
export * from "./DataSummary.vue?vue&type=script&lang=js"
import style0 from "./DataSummary.vue?vue&type=style&index=0&id=08a494d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a494d0",
  null
  
)

export default component.exports